export const skillsData = {
  languages: {
    icon: "python",
    title: "Languages",
    items: [
      { name: "C" },
      { name: "Java" },
      { name: "Python" },
      { name: "SQL" }
    ]
  },
  mlDataScience: {
    icon: "brain",
    title: "ML & Data Science",
    items: [
      { name: "NumPy" },
      { name: "Pandas" },
      { name: "Matplotlib" },
      { name: "Scikit-Learn" },
      { name: "TensorFlow" },
      { name: "PyTorch" }
    ]
  },
  backend: {
    icon: "server",
    title: "Backend Frameworks",
    items: [
      { name: "Django" },
      { name: "FastAPI" },
      { name: "Flask" }
    ]
  },
  tools: {
    icon: "tools",
    title: "Tools & Technologies",
    items: [
      { name: "Jupyter Notebook" },
      { name: "Google Colab" },
      { name: "Visual Studio Code" },
      { name: "GitHub (Version Control)" }
    ]
  }
};
